export default __webpack_public_path__ + "static/media/SE.ab220f05.svg";